import { filtersHelper } from '@/utils';
import { userModel } from '@/models/api/user.model';

export const workgroupModel = (data) => ({
    uuid: data.uuid,
    name: data.name,
    usageType: data.usage_type, // 1 - Task, 2 - Orientation
    isActive: data.is_active,
    createdAt: filtersHelper.getDateFormat(data.created_at),
    createdBy: data.created_by,
    updatedAt: filtersHelper.getDateFormat(data.updated_at),
    updatedBy: data.updated_by,
    deletedAt: filtersHelper.getDateFormat(data.deleted_at),
    deletedBy: data.deleted_by,
    workgroupUsers: (data?.workgroup_users ?? []).map(item => ({
        uuid: item.uuid,
        isAdmin: item.is_admin,
        isActive: item.is_active,
        createdBy: item.created_by,
        createdAt: filtersHelper.getDateFormat(item.created_at),
        updatedBy: item.updated_by,
        updatedAt: filtersHelper.getDateFormat(item.updated_at),
        deletedAt: filtersHelper.getDateFormat(item.deleted_at),
        deletedBy: item.deleted_by,
        user: item.user ? userModel(item.user) : null,
    })),
});